import { Result, Spin, message, Alert } from 'antd';
import dayjs from 'dayjs';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import { JobsDataType, StagesDataType } from '../../../ types';
import { StagesStore } from '../../../../DataSource/Stores/Cabinet/StagesStore';
import uWS from '../../../../uWS';
import JobsKanbanDeck from '../JobsKanbanDeck';
import Column from '../JobsKanbanDeck/Column';
import JobCard from './JobCard';

interface IProps {
  workspaceId: string;
}

const Kanban: FC<IProps> = ({ workspaceId }) => {
  useEffect(() => {
    StagesStore.getList(workspaceId).catch((e) => {
      console.error(e);
    });
  }, [workspaceId]);

  useEffect(() => {
    StagesStore.getListJobs(workspaceId).catch((e) => {
      console.error(e);
    });
  }, [workspaceId]);

  useEffect(() => {
    const eventStatus = uWS.subscribe(`workspaces/${workspaceId}/changeJob`, (data: any) => {
      if (data.error) {
        console.error('Error subscribing to workspace changeJob:', data.error);
        return;
      }

      StagesStore.getListJobs(workspaceId).catch((e) => {
        console.error(e);
      });
    });

    return () => {
      if (eventStatus) uWS.unSubscribe(`workspaces/${workspaceId}/changeJob`);
    };
  }, [workspaceId]);

  const onDropHandler = async (job: JobsDataType, stage: StagesDataType) => {
    StagesStore.setDataJobList(
      StagesStore.dataJobsList.map((item) =>
        item._id === job._id ? { ...item, stageId: stage._id } : item
      )
    );

    await StagesStore.updateJobStage(workspaceId, job._id, stage._id);

    if (StagesStore.jobUpdateError) {
      message.error('Ошибка');
    } else {
      message.info('Успешно');
      StagesStore.getListJobs(workspaceId).catch((e) => {
        console.error(e);
      });
    }
  };

  const calculateJobCardHeight = (job: JobsDataType) => {
    let height = 160;

    if (job.assignedTo) {
      height += 40;
    }

    if (!!job.labels?.length) {
      height += 26;
    }

    if (!!job.tags?.length) {
      height += 26;
    }

    return height + 8;
  };

  if (StagesStore.loadingError) return <Alert message="Ошибка загрузки" type="error" showIcon />;

  if (StagesStore.loading && StagesStore.dataList.length === 0)
    return <Spin size="small" fullscreen />;

  if (!StagesStore.loading && StagesStore.dataList.length === 0)
    return <Result status="warning" title="You don't have any stages" />;

  return (
    <JobsKanbanDeck
      columns={StagesStore.dataList}
      items={toJS(StagesStore.dataJobsList)}
      columnKeyField={'stageId'}
      renderColumn={(column) => <Column {...column} />}
      onDrop={onDropHandler}
      sort={(a, b) => dayjs(b.targetDate).unix() - dayjs(a.targetDate).unix()}
      rowHeight={calculateJobCardHeight}
    >
      {(item, dragProps) => <JobCard {...item} _job={item} dragProps={dragProps} />}
    </JobsKanbanDeck>
  );
};

export default observer(Kanban);
